import { useEffect, useState } from 'react';
import { api } from '~/lib/api';

export function DocumentPreviewFrame({ src, title }: { src: string; title: string }) {
  const [html, setHtml] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    setLoading(true);
    setError(null);

    api
      .getText(src)
      .then((data) => {
        if (!cancelled) setHtml(data);
      })
      .catch((err) => {
        if (!cancelled) setError(err.message || 'ไม่สามารถโหลดตัวอย่างเอกสารได้');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [src]);

  return (
    <div className="overflow-hidden rounded-md border border-border-base bg-surface-muted min-h-[400px]">
      {loading ? (
        <div className="flex h-[80vh] items-center justify-center text-text-muted">
          กำลังโหลดตัวอย่างเอกสาร...
        </div>
      ) : error ? (
        <div className="flex h-[80vh] items-center justify-center text-text-danger p-4 text-center">
          {error}
        </div>
      ) : (
        <iframe
          srcDoc={html || ''}
          title={title}
          className="h-[80vh] w-full border-0 bg-white"
          sandbox="allow-same-origin"
        />
      )}
    </div>
  );
}
